// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/admin.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/admin.proto.
 */
export const file_catpocs_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * ListAllProjectsRequest is the request message for ListAllProjects
 *
 * @generated from message catpocs.v1.ListAllProjectsRequest
 */
export type ListAllProjectsRequest = Message<"catpocs.v1.ListAllProjectsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];
};

/**
 * Describes the message catpocs.v1.ListAllProjectsRequest.
 * Use `create(ListAllProjectsRequestSchema)` to create a new message.
 */
export const ListAllProjectsRequestSchema: GenMessage<ListAllProjectsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 0);

/**
 * ProjectSummary provides a summary of a project
 *
 * @generated from message catpocs.v1.ProjectSummary
 */
export type ProjectSummary = Message<"catpocs.v1.ProjectSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string namespace = 3;
   */
  namespace: string;

  /**
   * @generated from field: int32 application_count = 4;
   */
  applicationCount: number;

  /**
   * @generated from field: int32 healthy_count = 5;
   */
  healthyCount: number;

  /**
   * @generated from field: int32 unhealthy_count = 6;
   */
  unhealthyCount: number;

  /**
   * @generated from field: repeated string owners = 7;
   */
  owners: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.ProjectSummary.
 * Use `create(ProjectSummarySchema)` to create a new message.
 */
export const ProjectSummarySchema: GenMessage<ProjectSummary> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 1);

/**
 * ListAllProjectsResponse is the response message for ListAllProjects
 *
 * @generated from message catpocs.v1.ListAllProjectsResponse
 */
export type ListAllProjectsResponse = Message<"catpocs.v1.ListAllProjectsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ProjectSummary projects = 1;
   */
  projects: ProjectSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListAllProjectsResponse.
 * Use `create(ListAllProjectsResponseSchema)` to create a new message.
 */
export const ListAllProjectsResponseSchema: GenMessage<ListAllProjectsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 2);

/**
 * GetAuditLogsRequest is the request message for GetAuditLogs
 *
 * @generated from message catpocs.v1.GetAuditLogsRequest
 */
export type GetAuditLogsRequest = Message<"catpocs.v1.GetAuditLogsRequest"> & {
  /**
   * Optional filter by project
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Optional filter by user
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Optional filter by action (e.g., "create", "update", "delete", "login")
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * Optional filter by resource type (e.g., "project", "application", "repository")
   *
   * @generated from field: string resource_type = 4;
   */
  resourceType: string;

  /**
   * Optional filter by status ("success", "failure")
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * Optional search by resource name or user email
   *
   * @generated from field: string search = 6;
   */
  search: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 7;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 8;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: int32 page_size = 9;
   */
  pageSize: number;

  /**
   * Number of records to skip for pagination
   *
   * @generated from field: int32 skip = 10;
   */
  skip: number;
};

/**
 * Describes the message catpocs.v1.GetAuditLogsRequest.
 * Use `create(GetAuditLogsRequestSchema)` to create a new message.
 */
export const GetAuditLogsRequestSchema: GenMessage<GetAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 3);

/**
 * AuditLogEntry represents an audit log entry
 *
 * @generated from message catpocs.v1.AuditLogEntry
 */
export type AuditLogEntry = Message<"catpocs.v1.AuditLogEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string user_email = 4;
   */
  userEmail: string;

  /**
   * @generated from field: string action = 5;
   */
  action: string;

  /**
   * @generated from field: string resource_type = 6;
   */
  resourceType: string;

  /**
   * @generated from field: string resource_id = 7;
   */
  resourceId: string;

  /**
   * @generated from field: string resource_name = 8;
   */
  resourceName: string;

  /**
   * @generated from field: string project_id = 9;
   */
  projectId: string;

  /**
   * @generated from field: map<string, string> details = 10;
   */
  details: { [key: string]: string };

  /**
   * @generated from field: string ip_address = 11;
   */
  ipAddress: string;

  /**
   * "success" or "failure"
   *
   * @generated from field: string status = 12;
   */
  status: string;
};

/**
 * Describes the message catpocs.v1.AuditLogEntry.
 * Use `create(AuditLogEntrySchema)` to create a new message.
 */
export const AuditLogEntrySchema: GenMessage<AuditLogEntry> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 4);

/**
 * GetAuditLogsResponse is the response message for GetAuditLogs
 *
 * @generated from message catpocs.v1.GetAuditLogsResponse
 */
export type GetAuditLogsResponse = Message<"catpocs.v1.GetAuditLogsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.AuditLogEntry logs = 1;
   */
  logs: AuditLogEntry[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.GetAuditLogsResponse.
 * Use `create(GetAuditLogsResponseSchema)` to create a new message.
 */
export const GetAuditLogsResponseSchema: GenMessage<GetAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 5);

/**
 * GetOperatorMetricsRequest is the request message for GetOperatorMetrics
 *
 * @generated from message catpocs.v1.GetOperatorMetricsRequest
 */
export type GetOperatorMetricsRequest = Message<"catpocs.v1.GetOperatorMetricsRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetOperatorMetricsRequest.
 * Use `create(GetOperatorMetricsRequestSchema)` to create a new message.
 */
export const GetOperatorMetricsRequestSchema: GenMessage<GetOperatorMetricsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 6);

/**
 * OperatorMetrics provides metrics about the operator
 *
 * @generated from message catpocs.v1.OperatorMetrics
 */
export type OperatorMetrics = Message<"catpocs.v1.OperatorMetrics"> & {
  /**
   * @generated from field: int32 total_projects = 1;
   */
  totalProjects: number;

  /**
   * @generated from field: int32 total_applications = 2;
   */
  totalApplications: number;

  /**
   * @generated from field: int32 healthy_applications = 3;
   */
  healthyApplications: number;

  /**
   * @generated from field: int32 synced_applications = 4;
   */
  syncedApplications: number;

  /**
   * @generated from field: int32 out_of_sync_applications = 5;
   */
  outOfSyncApplications: number;

  /**
   * @generated from field: int32 degraded_applications = 6;
   */
  degradedApplications: number;

  /**
   * @generated from field: double avg_sync_duration_seconds = 7;
   */
  avgSyncDurationSeconds: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_reconcile_time = 8;
   */
  lastReconcileTime?: Timestamp;
};

/**
 * Describes the message catpocs.v1.OperatorMetrics.
 * Use `create(OperatorMetricsSchema)` to create a new message.
 */
export const OperatorMetricsSchema: GenMessage<OperatorMetrics> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 7);

/**
 * GetOperatorMetricsResponse is the response message for GetOperatorMetrics
 *
 * @generated from message catpocs.v1.GetOperatorMetricsResponse
 */
export type GetOperatorMetricsResponse = Message<"catpocs.v1.GetOperatorMetricsResponse"> & {
  /**
   * @generated from field: catpocs.v1.OperatorMetrics metrics = 1;
   */
  metrics?: OperatorMetrics;
};

/**
 * Describes the message catpocs.v1.GetOperatorMetricsResponse.
 * Use `create(GetOperatorMetricsResponseSchema)` to create a new message.
 */
export const GetOperatorMetricsResponseSchema: GenMessage<GetOperatorMetricsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 8);

/**
 * ValidateRepositoryRequest is the request message for ValidateRepository
 *
 * @generated from message catpocs.v1.ValidateRepositoryRequest
 */
export type ValidateRepositoryRequest = Message<"catpocs.v1.ValidateRepositoryRequest"> & {
  /**
   * @generated from field: string repo_url = 1;
   */
  repoUrl: string;

  /**
   * @generated from field: string helm_path = 2;
   */
  helmPath: string;
};

/**
 * Describes the message catpocs.v1.ValidateRepositoryRequest.
 * Use `create(ValidateRepositoryRequestSchema)` to create a new message.
 */
export const ValidateRepositoryRequestSchema: GenMessage<ValidateRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 9);

/**
 * ValidationResult represents the result of a validation check
 *
 * @generated from message catpocs.v1.ValidationResult
 */
export type ValidationResult = Message<"catpocs.v1.ValidationResult"> & {
  /**
   * @generated from field: string check = 1;
   */
  check: string;

  /**
   * @generated from field: bool passed = 2;
   */
  passed: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.ValidationResult.
 * Use `create(ValidationResultSchema)` to create a new message.
 */
export const ValidationResultSchema: GenMessage<ValidationResult> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 10);

/**
 * ValidateRepositoryResponse is the response message for ValidateRepository
 *
 * @generated from message catpocs.v1.ValidateRepositoryResponse
 */
export type ValidateRepositoryResponse = Message<"catpocs.v1.ValidateRepositoryResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: repeated catpocs.v1.ValidationResult results = 2;
   */
  results: ValidationResult[];
};

/**
 * Describes the message catpocs.v1.ValidateRepositoryResponse.
 * Use `create(ValidateRepositoryResponseSchema)` to create a new message.
 */
export const ValidateRepositoryResponseSchema: GenMessage<ValidateRepositoryResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 11);

/**
 * GetSystemHealthRequest is the request message for GetSystemHealth
 *
 * @generated from message catpocs.v1.GetSystemHealthRequest
 */
export type GetSystemHealthRequest = Message<"catpocs.v1.GetSystemHealthRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetSystemHealthRequest.
 * Use `create(GetSystemHealthRequestSchema)` to create a new message.
 */
export const GetSystemHealthRequestSchema: GenMessage<GetSystemHealthRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 12);

/**
 * ServiceHealth represents the health status of a service component
 *
 * @generated from message catpocs.v1.ServiceHealth
 */
export type ServiceHealth = Message<"catpocs.v1.ServiceHealth"> & {
  /**
   * Service name (e.g., "argocd", "kubernetes", "github")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "healthy", "degraded", "unhealthy", "unknown"
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Human-readable status message
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * Last health check time
   *
   * @generated from field: google.protobuf.Timestamp last_check = 4;
   */
  lastCheck?: Timestamp;

  /**
   * Additional details (e.g., version, endpoint)
   *
   * @generated from field: map<string, string> details = 5;
   */
  details: { [key: string]: string };
};

/**
 * Describes the message catpocs.v1.ServiceHealth.
 * Use `create(ServiceHealthSchema)` to create a new message.
 */
export const ServiceHealthSchema: GenMessage<ServiceHealth> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 13);

/**
 * ControllerHealth represents the health of the K8s controller/watcher
 *
 * @generated from message catpocs.v1.ControllerHealth
 */
export type ControllerHealth = Message<"catpocs.v1.ControllerHealth"> & {
  /**
   * Whether the controller is running
   *
   * @generated from field: bool running = 1;
   */
  running: boolean;

  /**
   * Number of applications being watched
   *
   * @generated from field: int32 watched_applications = 2;
   */
  watchedApplications: number;

  /**
   * Last successful reconcile
   *
   * @generated from field: google.protobuf.Timestamp last_reconcile = 3;
   */
  lastReconcile?: Timestamp;

  /**
   * Reconcile errors in last 24h
   *
   * @generated from field: int32 reconcile_errors_24h = 4;
   */
  reconcileErrors24h: number;

  /**
   * "healthy", "degraded", "unhealthy"
   *
   * @generated from field: string status = 5;
   */
  status: string;
};

/**
 * Describes the message catpocs.v1.ControllerHealth.
 * Use `create(ControllerHealthSchema)` to create a new message.
 */
export const ControllerHealthSchema: GenMessage<ControllerHealth> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 14);

/**
 * ApplicationHealthSummary provides aggregate health across all managed applications
 *
 * @generated from message catpocs.v1.ApplicationHealthSummary
 */
export type ApplicationHealthSummary = Message<"catpocs.v1.ApplicationHealthSummary"> & {
  /**
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * @generated from field: int32 healthy = 2;
   */
  healthy: number;

  /**
   * @generated from field: int32 degraded = 3;
   */
  degraded: number;

  /**
   * @generated from field: int32 progressing = 4;
   */
  progressing: number;

  /**
   * @generated from field: int32 suspended = 5;
   */
  suspended: number;

  /**
   * @generated from field: int32 missing = 6;
   */
  missing: number;

  /**
   * @generated from field: int32 unknown = 7;
   */
  unknown: number;

  /**
   * @generated from field: int32 synced = 8;
   */
  synced: number;

  /**
   * @generated from field: int32 out_of_sync = 9;
   */
  outOfSync: number;

  /**
   * Sync failures in last 24 hours
   *
   * @generated from field: int32 sync_failed_24h = 10;
   */
  syncFailed24h: number;
};

/**
 * Describes the message catpocs.v1.ApplicationHealthSummary.
 * Use `create(ApplicationHealthSummarySchema)` to create a new message.
 */
export const ApplicationHealthSummarySchema: GenMessage<ApplicationHealthSummary> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 15);

/**
 * GetSystemHealthResponse is the response message for GetSystemHealth
 *
 * @generated from message catpocs.v1.GetSystemHealthResponse
 */
export type GetSystemHealthResponse = Message<"catpocs.v1.GetSystemHealthResponse"> & {
  /**
   * "healthy", "degraded", "unhealthy"
   *
   * @generated from field: string overall_status = 1;
   */
  overallStatus: string;

  /**
   * Individual service health
   *
   * @generated from field: repeated catpocs.v1.ServiceHealth services = 2;
   */
  services: ServiceHealth[];

  /**
   * K8s controller/watcher health
   *
   * @generated from field: catpocs.v1.ControllerHealth controller = 3;
   */
  controller?: ControllerHealth;

  /**
   * Server time for sync check
   *
   * @generated from field: google.protobuf.Timestamp server_time = 4;
   */
  serverTime?: Timestamp;

  /**
   * Aggregate application health
   *
   * @generated from field: catpocs.v1.ApplicationHealthSummary applications = 5;
   */
  applications?: ApplicationHealthSummary;
};

/**
 * Describes the message catpocs.v1.GetSystemHealthResponse.
 * Use `create(GetSystemHealthResponseSchema)` to create a new message.
 */
export const GetSystemHealthResponseSchema: GenMessage<GetSystemHealthResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 16);

/**
 * SessionInfo represents an active user session
 *
 * @generated from message catpocs.v1.SessionInfo
 */
export type SessionInfo = Message<"catpocs.v1.SessionInfo"> & {
  /**
   * Unique session identifier
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * User ID
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * User email
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * User name
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Session creation time
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Last activity timestamp
   *
   * @generated from field: google.protobuf.Timestamp last_activity = 6;
   */
  lastActivity?: Timestamp;

  /**
   * Session expiry time
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp;

  /**
   * Whether session is currently active
   *
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * Whether this is an impersonation session
   *
   * @generated from field: bool is_impersonating = 9;
   */
  isImpersonating: boolean;

  /**
   * Impersonated user ID (if applicable)
   *
   * @generated from field: string impersonated_user_id = 10;
   */
  impersonatedUserId: string;

  /**
   * Impersonated user email (if applicable)
   *
   * @generated from field: string impersonated_email = 11;
   */
  impersonatedEmail: string;

  /**
   * IP address of the session
   *
   * @generated from field: string ip_address = 12;
   */
  ipAddress: string;

  /**
   * User agent (browser/device info)
   *
   * @generated from field: string user_agent = 13;
   */
  userAgent: string;
};

/**
 * Describes the message catpocs.v1.SessionInfo.
 * Use `create(SessionInfoSchema)` to create a new message.
 */
export const SessionInfoSchema: GenMessage<SessionInfo> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 17);

/**
 * ListActiveSessionsRequest is the request message for ListActiveSessions
 *
 * @generated from message catpocs.v1.ListActiveSessionsRequest
 */
export type ListActiveSessionsRequest = Message<"catpocs.v1.ListActiveSessionsRequest"> & {
  /**
   * Optional: filter by user ID (empty = all sessions)
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Optional: search by user email or name
   *
   * @generated from field: string search = 2;
   */
  search: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: int32 skip = 4;
   */
  skip: number;
};

/**
 * Describes the message catpocs.v1.ListActiveSessionsRequest.
 * Use `create(ListActiveSessionsRequestSchema)` to create a new message.
 */
export const ListActiveSessionsRequestSchema: GenMessage<ListActiveSessionsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 18);

/**
 * ListActiveSessionsResponse is the response message for ListActiveSessions
 *
 * @generated from message catpocs.v1.ListActiveSessionsResponse
 */
export type ListActiveSessionsResponse = Message<"catpocs.v1.ListActiveSessionsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.SessionInfo sessions = 1;
   */
  sessions: SessionInfo[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListActiveSessionsResponse.
 * Use `create(ListActiveSessionsResponseSchema)` to create a new message.
 */
export const ListActiveSessionsResponseSchema: GenMessage<ListActiveSessionsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 19);

/**
 * RevokeSessionRequest is the request message for RevokeSession
 *
 * @generated from message catpocs.v1.RevokeSessionRequest
 */
export type RevokeSessionRequest = Message<"catpocs.v1.RevokeSessionRequest"> & {
  /**
   * Session ID to revoke
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message catpocs.v1.RevokeSessionRequest.
 * Use `create(RevokeSessionRequestSchema)` to create a new message.
 */
export const RevokeSessionRequestSchema: GenMessage<RevokeSessionRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 20);

/**
 * RevokeSessionResponse is the response message for RevokeSession
 *
 * @generated from message catpocs.v1.RevokeSessionResponse
 */
export type RevokeSessionResponse = Message<"catpocs.v1.RevokeSessionResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.RevokeSessionResponse.
 * Use `create(RevokeSessionResponseSchema)` to create a new message.
 */
export const RevokeSessionResponseSchema: GenMessage<RevokeSessionResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 21);

/**
 * RevokeUserSessionsRequest is the request message for RevokeUserSessions
 *
 * @generated from message catpocs.v1.RevokeUserSessionsRequest
 */
export type RevokeUserSessionsRequest = Message<"catpocs.v1.RevokeUserSessionsRequest"> & {
  /**
   * User ID whose sessions to revoke
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message catpocs.v1.RevokeUserSessionsRequest.
 * Use `create(RevokeUserSessionsRequestSchema)` to create a new message.
 */
export const RevokeUserSessionsRequestSchema: GenMessage<RevokeUserSessionsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 22);

/**
 * RevokeUserSessionsResponse is the response message for RevokeUserSessions
 *
 * @generated from message catpocs.v1.RevokeUserSessionsResponse
 */
export type RevokeUserSessionsResponse = Message<"catpocs.v1.RevokeUserSessionsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Number of sessions revoked
   *
   * @generated from field: int32 revoked_count = 2;
   */
  revokedCount: number;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.RevokeUserSessionsResponse.
 * Use `create(RevokeUserSessionsResponseSchema)` to create a new message.
 */
export const RevokeUserSessionsResponseSchema: GenMessage<RevokeUserSessionsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 23);

/**
 * UserInfo represents a user in the system
 *
 * @generated from message catpocs.v1.UserInfo
 */
export type UserInfo = Message<"catpocs.v1.UserInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated string groups = 4;
   */
  groups: string[];

  /**
   * @generated from field: bool is_super_admin = 5;
   */
  isSuperAdmin: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp last_sign_in = 6;
   */
  lastSignIn?: Timestamp;

  /**
   * @generated from field: int32 total_sign_ins = 7;
   */
  totalSignIns: number;

  /**
   * Number of projects user has access to
   *
   * @generated from field: int32 projects_count = 8;
   */
  projectsCount: number;

  /**
   * Number of active sessions
   *
   * @generated from field: int32 active_sessions = 9;
   */
  activeSessions: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.UserInfo.
 * Use `create(UserInfoSchema)` to create a new message.
 */
export const UserInfoSchema: GenMessage<UserInfo> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 24);

/**
 * ListUsersRequest is the request message for ListUsers
 *
 * @generated from message catpocs.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"catpocs.v1.ListUsersRequest"> & {
  /**
   * Optional search by email or name
   *
   * @generated from field: string search = 1;
   */
  search: string;

  /**
   * Optional filter: "super_admin", "active", "inactive"
   *
   * @generated from field: string filter = 2;
   */
  filter: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: int32 skip = 4;
   */
  skip: number;
};

/**
 * Describes the message catpocs.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 25);

/**
 * ListUsersResponse is the response message for ListUsers
 *
 * @generated from message catpocs.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"catpocs.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.UserInfo users = 1;
   */
  users: UserInfo[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 26);

/**
 * UserStatistics provides aggregate statistics about users
 *
 * @generated from message catpocs.v1.UserStatistics
 */
export type UserStatistics = Message<"catpocs.v1.UserStatistics"> & {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers: number;

  /**
   * Users who signed in within last 30 days
   *
   * @generated from field: int32 active_users_30d = 2;
   */
  activeUsers30d: number;

  /**
   * Users created within last 7 days
   *
   * @generated from field: int32 new_users_7d = 3;
   */
  newUsers7d: number;

  /**
   * @generated from field: int32 super_admins = 4;
   */
  superAdmins: number;

  /**
   * @generated from field: int32 total_sessions = 5;
   */
  totalSessions: number;
};

/**
 * Describes the message catpocs.v1.UserStatistics.
 * Use `create(UserStatisticsSchema)` to create a new message.
 */
export const UserStatisticsSchema: GenMessage<UserStatistics> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 27);

/**
 * GetUserStatisticsRequest is the request message for GetUserStatistics
 *
 * @generated from message catpocs.v1.GetUserStatisticsRequest
 */
export type GetUserStatisticsRequest = Message<"catpocs.v1.GetUserStatisticsRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetUserStatisticsRequest.
 * Use `create(GetUserStatisticsRequestSchema)` to create a new message.
 */
export const GetUserStatisticsRequestSchema: GenMessage<GetUserStatisticsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 28);

/**
 * GetUserStatisticsResponse is the response message for GetUserStatistics
 *
 * @generated from message catpocs.v1.GetUserStatisticsResponse
 */
export type GetUserStatisticsResponse = Message<"catpocs.v1.GetUserStatisticsResponse"> & {
  /**
   * @generated from field: catpocs.v1.UserStatistics statistics = 1;
   */
  statistics?: UserStatistics;
};

/**
 * Describes the message catpocs.v1.GetUserStatisticsResponse.
 * Use `create(GetUserStatisticsResponseSchema)` to create a new message.
 */
export const GetUserStatisticsResponseSchema: GenMessage<GetUserStatisticsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 29);

/**
 * StartImpersonationRequest is the request message for StartImpersonation
 *
 * @generated from message catpocs.v1.StartImpersonationRequest
 */
export type StartImpersonationRequest = Message<"catpocs.v1.StartImpersonationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated string groups = 4;
   */
  groups: string[];
};

/**
 * Describes the message catpocs.v1.StartImpersonationRequest.
 * Use `create(StartImpersonationRequestSchema)` to create a new message.
 */
export const StartImpersonationRequestSchema: GenMessage<StartImpersonationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 30);

/**
 * StartImpersonationResponse is the response message for StartImpersonation
 *
 * @generated from message catpocs.v1.StartImpersonationResponse
 */
export type StartImpersonationResponse = Message<"catpocs.v1.StartImpersonationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.StartImpersonationResponse.
 * Use `create(StartImpersonationResponseSchema)` to create a new message.
 */
export const StartImpersonationResponseSchema: GenMessage<StartImpersonationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 31);

/**
 * StopImpersonationRequest is the request message for StopImpersonation
 *
 * @generated from message catpocs.v1.StopImpersonationRequest
 */
export type StopImpersonationRequest = Message<"catpocs.v1.StopImpersonationRequest"> & {
};

/**
 * Describes the message catpocs.v1.StopImpersonationRequest.
 * Use `create(StopImpersonationRequestSchema)` to create a new message.
 */
export const StopImpersonationRequestSchema: GenMessage<StopImpersonationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 32);

/**
 * StopImpersonationResponse is the response message for StopImpersonation
 *
 * @generated from message catpocs.v1.StopImpersonationResponse
 */
export type StopImpersonationResponse = Message<"catpocs.v1.StopImpersonationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.StopImpersonationResponse.
 * Use `create(StopImpersonationResponseSchema)` to create a new message.
 */
export const StopImpersonationResponseSchema: GenMessage<StopImpersonationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_admin, 33);

/**
 * AdminService provides administrative operations
 *
 * @generated from service catpocs.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * ListAllProjects lists all projects (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.ListAllProjects
   */
  listAllProjects: {
    methodKind: "unary";
    input: typeof ListAllProjectsRequestSchema;
    output: typeof ListAllProjectsResponseSchema;
  },
  /**
   * GetAuditLogs retrieves audit logs with enhanced filtering
   *
   * @generated from rpc catpocs.v1.AdminService.GetAuditLogs
   */
  getAuditLogs: {
    methodKind: "unary";
    input: typeof GetAuditLogsRequestSchema;
    output: typeof GetAuditLogsResponseSchema;
  },
  /**
   * GetOperatorMetrics retrieves operator metrics
   *
   * @generated from rpc catpocs.v1.AdminService.GetOperatorMetrics
   */
  getOperatorMetrics: {
    methodKind: "unary";
    input: typeof GetOperatorMetricsRequestSchema;
    output: typeof GetOperatorMetricsResponseSchema;
  },
  /**
   * ValidateRepository validates a GitHub repository
   *
   * @generated from rpc catpocs.v1.AdminService.ValidateRepository
   */
  validateRepository: {
    methodKind: "unary";
    input: typeof ValidateRepositoryRequestSchema;
    output: typeof ValidateRepositoryResponseSchema;
  },
  /**
   * GetSystemHealth retrieves system health status (ArgoCD, K8s, GitHub, etc.)
   *
   * @generated from rpc catpocs.v1.AdminService.GetSystemHealth
   */
  getSystemHealth: {
    methodKind: "unary";
    input: typeof GetSystemHealthRequestSchema;
    output: typeof GetSystemHealthResponseSchema;
  },
  /**
   * ListActiveSessions lists all active user sessions with pagination (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.ListActiveSessions
   */
  listActiveSessions: {
    methodKind: "unary";
    input: typeof ListActiveSessionsRequestSchema;
    output: typeof ListActiveSessionsResponseSchema;
  },
  /**
   * RevokeSession revokes a specific session (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.RevokeSession
   */
  revokeSession: {
    methodKind: "unary";
    input: typeof RevokeSessionRequestSchema;
    output: typeof RevokeSessionResponseSchema;
  },
  /**
   * RevokeUserSessions revokes all sessions for a user (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.RevokeUserSessions
   */
  revokeUserSessions: {
    methodKind: "unary";
    input: typeof RevokeUserSessionsRequestSchema;
    output: typeof RevokeUserSessionsResponseSchema;
  },
  /**
   * ListUsers lists all users with detailed information and filtering (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * GetUserStatistics retrieves aggregate user statistics (admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.GetUserStatistics
   */
  getUserStatistics: {
    methodKind: "unary";
    input: typeof GetUserStatisticsRequestSchema;
    output: typeof GetUserStatisticsResponseSchema;
  },
  /**
   * StartImpersonation starts impersonating a user (super admin only)
   *
   * @generated from rpc catpocs.v1.AdminService.StartImpersonation
   */
  startImpersonation: {
    methodKind: "unary";
    input: typeof StartImpersonationRequestSchema;
    output: typeof StartImpersonationResponseSchema;
  },
  /**
   * StopImpersonation stops impersonating a user
   *
   * @generated from rpc catpocs.v1.AdminService.StopImpersonation
   */
  stopImpersonation: {
    methodKind: "unary";
    input: typeof StopImpersonationRequestSchema;
    output: typeof StopImpersonationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_admin, 0);

